import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import WorkQueues from 'enums/workQueue.enum';
import { listUnReconciledOrdersByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import ReconcileShipmentTable from './ReconcileShipmentTable';
import ReconcileShipmentFilterButton from './ReconcileShipmentFilterButton';
import ReconcileShipmentFilterStatusBar from './ReconcileShipmentFilterStatusBar';

const ReconcileShipment = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(({ workQueue }) => workQueue.reconcileShipment, shallowEqual);
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.RECONCILE_SHIPMENT)) {
      dispatch(listUnReconciledOrdersByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.RECONCILE_SHIPMENT) {
    return null;
  }

  return (
    <Grid container sx={{ py: 3 }} justifyContent='space-between' alignItems='center'>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }}>
        <ReconcileShipmentFilterStatusBar />
      </Grid>
      <Grid item>
        <Grid container gap={2}>
          <Grid item>
            <ReconcileShipmentFilterButton />
          </Grid>
        </Grid>
      </Grid>
      <ReconcileShipmentTable />
    </Grid>
  );
};
export default ReconcileShipment;
